import { Inventory } from 'actions/actionTypes';

export const loadInventoryListRequest = () => ({ type: Inventory.LOAD_INVENTORY_LIST_REQUEST });
export const loadInventoryListSuccess = (responseData) => ({ type: Inventory.LOAD_INVENTORY_LIST_SUCCESS, payload: responseData });
export const loadInventoryListFailure = (errorMessage) => ({ type: Inventory.LOAD_INVENTORY_LIST_FAILURE, payload: errorMessage });

export const addPurchaseShopItemId = (itemId) => ({type:Inventory.PURCHASE_SHOP_ITEM_ID, payload: itemId});
export const itemResetTimer = (level) => ({type:Inventory.RESET_TIMER, payload:level});